import { BlockStack, Card, InlineStack, SkeletonBodyText, SkeletonDisplayText } from "@shopify/polaris"
import React from "react"

export const renderSkeleton = () => {
    let n = 1
    return (
        <React.Fragment>
            {[...Array(n)].map((_, index) => (
                <Card roundedAbove='sm' key={index}>
                    <BlockStack gap="400">
                        <BlockStack gap="200">
                            <div className="Custom_subs_overview_skelton">
                                <InlineStack wrap={false} gap="200" align='space-between'>
                                    <SkeletonDisplayText size='small' />
                                    <SkeletonDisplayText size='small' />
                                </InlineStack>
                            </div>
                            <SkeletonBodyText lines={2} />
                        </BlockStack>
                        <Card>
                            <BlockStack gap="100">
                                <BlockStack gap="500">
                                    <SkeletonBodyText lines={2} />
                                    <SkeletonBodyText lines={1} />
                                    <SkeletonBodyText lines={2} />
                                </BlockStack>
                            </BlockStack>
                        </Card>
                    </BlockStack>
                </Card>
            ))}
        </React.Fragment>
    )
}